import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { channelDeferred } from './channelDeferred';
import { getSessionId } from './getSessionId';
import { desktopVersion } from '@trello/config';
import { isBrowserSupported, browserStr } from '@trello/browser';

export const sendChunkLoadErrorEvent = async (error: Error) => {
  const channel = await channelDeferred.getValueAsync();
  const source = getScreenFromUrl();

  Analytics.sendOperationalEvent({
    source,
    action: 'errored',
    actionSubject: 'chunkLoad',
    attributes: {
      trelloSessionId: getSessionId(),
      channel,
      isBrowserSupported: isBrowserSupported(),
      browser: browserStr,
      desktopVersion: desktopVersion,
      stack: error.stack,
      name: 'HandledChunkLoadError',
    },
  });
};
